import {ICategoriesResponse, ICategoryState} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {createCategory, deleteCategory, getCategories, updateCategory} from "./ActionCreators";

const initialValue: ICategoryState = {
    items: [],
    fetchCategoriesLoading: false,
    categoryActionLoading: false
}


const categorySlice = createSlice({
    name: SliceNames.CATEGORY,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getCategories.pending, (state) => {
                state.fetchCategoriesLoading = true
            })
            .addCase(
                getCategories.fulfilled, (state, action: PayloadAction<ICategoriesResponse[]>) => {
                    state.items = action.payload
                    state.fetchCategoriesLoading = false
                })
            .addCase(
                getCategories.rejected, (state) => {
                    state.fetchCategoriesLoading = false
                })
            .addCase(
                createCategory.pending, (state) => {
                    state.categoryActionLoading = true
                })
            .addCase(
                createCategory.fulfilled, (state, action: PayloadAction<ICategoriesResponse>) => {
                    state.items = [...state.items, action.payload]
                    state.categoryActionLoading = false
                })
            .addCase(
                createCategory.rejected, (state) => {
                    state.categoryActionLoading = false
                })
            .addCase(
                deleteCategory.pending, (state) => {
                    state.categoryActionLoading = true
                })
            .addCase(
                deleteCategory.fulfilled, (state, action: PayloadAction<string>) => {
                    state.items = [...state.items].filter((c) => c.id !== action.payload)
                    state.categoryActionLoading = false
                })
            .addCase(
                deleteCategory.rejected, (state) => {
                    state.categoryActionLoading = false
                })
            .addCase(
                updateCategory.pending, (state) => {
                    state.categoryActionLoading = true
                })
            .addCase(
                updateCategory.fulfilled, (state, action: PayloadAction<ICategoriesResponse>) => {
                    state.items = [...state.items.map(el => (el.id === action.payload.id ? {
                        ...el, ...action.payload,
                        count: el.count
                    } : el))]
                    state.categoryActionLoading = false
                })
            .addCase(
                updateCategory.rejected, (state) => {
                    state.categoryActionLoading = false
                })
    }
})

export default categorySlice.reducer

